import { environment } from "./environment";

export class AppConfig {
    public static salarioMinimo():number{ return  Number(`${environment.MINIMUN_SALARY}` );  }
}